import React from 'react';
import Typography from 'kingpin/atoms/Typography';
import Button from 'kingpin/atoms/Button';
import Row from '../../Common/Row';
import ChangePassword from './ChagePassword';
import TextInput from '../../../kingpin/atoms/TextInput';
import Card from '../../Common/Card';

const Profile = ({
  onSave,
  displayName,
  onDisplayNameChanged,
  isSaving,
}: {
  onSave: () => void;
  displayName: string;
  onDisplayNameChanged: (event: React.ChangeEvent<HTMLInputElement>) => void;
  isSaving: boolean;
}) => (
  <div>
    <Card style={{ marginBottom: 32, padding: '16px 24px', width: '40vw' }}>
      <div style={{ marginBottom: 24 }}>
        <Typography.Header type="H4">Profile</Typography.Header>
        <Typography.Header type="H5" color={'var(--color-grey-5)'}>
          Update your personal information
        </Typography.Header>
      </div>
      <div style={{ marginBottom: 16 }}>
        <TextInput
          value={displayName}
          onChange={onDisplayNameChanged}
          label="Full Name"
        />
      </div>
      <div>
        <Row spaceBetween>
          <div />
          <Button
            isLoading={isSaving}
            isDisabled={isSaving}
            label="Update Profile"
            size="Small"
            type="Primary"
            onClick={onSave}
          />
        </Row>
      </div>
    </Card>
    <Card style={{ marginBottom: 32, padding: '16px 24px' }}>
      <ChangePassword />
    </Card>
  </div>
);

export default Profile;
